import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  toggle: () => void;
  setTheme: (t: Theme) => void;
}

/**
 * Backoffice theme toggle. MARCA: BO is light by default, dark optional.
 * The `.dark` class is applied on the <AppShell> root node, not <html>,
 * so the login screen keeps its own fixed palette.
 */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'light',
      toggle: () => set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' })),
      setTheme: (theme) => set({ theme }),
    }),
    { name: 'c4t-bo-theme' },
  ),
);
